(() => {
  const media = window.matchMedia('(max-width: 749px)');

  function fixAfterpayPosition() {
    if (!media.matches) return;
    const details = document.querySelector('.product-details');
    if (!details) return;

    const buyBlock = details.querySelector('.buy-buttons-block') ||
      details.querySelector('.product-form-buttons')?.closest('.shopify-block, [id^="shopify-block-"], .block') ||
      details.querySelector('.product-form-buttons');

    const placement = details.querySelector('afterpay-placement, square-placement, [data-afterpay-placement]');
    if (!buyBlock || !placement) return;

    const afterpayBlock = placement.closest('.shopify-block, [id^="shopify-block-"], .app-block') || placement.parentElement;
    if (!afterpayBlock) return;

    afterpayBlock.classList.add('gpt-afterpay-moved');
    if (buyBlock.nextElementSibling !== afterpayBlock) {
      buyBlock.insertAdjacentElement('afterend', afterpayBlock);
    }
  }

  function start() {
    fixAfterpayPosition();
    const observer = new MutationObserver(fixAfterpayPosition);
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', start)
    : start();
})();
